import React from 'react';
import { CustomButton } from '@/components/atomic';
import { ICONS } from '@/constants/constants';
import Image from 'next/image';

interface PasswordChangedModalProps {
  onLoginNow: () => void;
}

const PasswordChangedModal: React.FC<PasswordChangedModalProps> = ({ onLoginNow }) => {
  return (
    <div className="w-full text-center">
      {/* Success Icon */}
      <div className="flex justify-center mb-6">
        {/* <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="white">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
        </div> */}
        <Image src={ICONS.greenTick} alt="green tick" width={44} height={44} />
      </div>

      {/* Title */}
      <h2 className="font-rakesly text-xl font-bold text-gray-800 tracking-wide mb-4">
        PASSWORD CHANGED!
      </h2>

      {/* Description */}
      <p className="text-gray-600 font-sans text-sm mb-8 leading-relaxed">
        Your password has been changed successfully.
      </p>

      {/* Login Button */}
      <CustomButton 
        onClick={onLoginNow}
        className="w-full bg-gray-800 text-white py-2 px-4 rounded-lg font-sans font-medium hover:bg-gray-700 transition-all duration-200"
      >
        Login Now
      </CustomButton>
    </div>
  );
};

export default PasswordChangedModal; 